// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"175":"160e8778","233":"d2da6ec4","369":"547d52ab","936":"25eb7461"}[chunkId] + ".css";
};